export const SET_SHIP_OPTION_DATA_LOADING = 'SET_SHIP_OPTION_DATA_LOADING';
export const SET_SHIP_OPTIONS_NOT_LOADED = 'SET_SHIP_OPTIONS_NOT_LOADED';
